export default __webpack_public_path__ + "static/media/motor.08497f37.png";